import React from "react";
import { Trophy } from "lucide-react";
import ProfileSectionCard from "../components/ProfileSectionCard";
import { useProfileHub } from "../ProfileHubContext";

export default function ProfileRankingsSection() {
  const { summary } = useProfileHub();

  return (
    <div className="space-y-6">
      <div className="grid gap-6 lg:grid-cols-[0.9fr,1.1fr]">
        <ProfileSectionCard
          title="Classement global"
          subtitle="Espace prepare pour brancher un vrai ranking joueur plus tard, sans casser l'UX actuelle."
        >
          <div className="rounded-[28px] border border-dashed border-slate-300 bg-[linear-gradient(145deg,#f8fafc,#eef2ff)] p-6">
            <div className="flex items-center gap-3">
              <div className="rounded-2xl bg-slate-950 p-3 text-white">
                <Trophy className="h-5 w-5" />
              </div>
              <div>
                <div className="font-semibold text-slate-900">
                  Leaderboard global a brancher
                </div>
                <div className="mt-1 text-sm text-slate-500">
                  Le layout est deja pret. En attendant, on expose des highlights
                  reels issus de l'historique du joueur.
                </div>
              </div>
            </div>
          </div>
        </ProfileSectionCard>

        <ProfileSectionCard
          title="Highlights joueur"
          subtitle="Indicateurs reels pour garder une section classements utile des maintenant."
        >
          <div className="grid gap-3 sm:grid-cols-3">
            <div className="rounded-2xl border border-slate-200 bg-slate-50 px-4 py-4">
              <div className="text-[11px] uppercase tracking-[0.18em] text-slate-400">
                Top 1
              </div>
              <div className="mt-2 text-2xl font-semibold text-slate-950">
                {summary.wins}
              </div>
            </div>
            <div className="rounded-2xl border border-slate-200 bg-slate-50 px-4 py-4">
              <div className="text-[11px] uppercase tracking-[0.18em] text-slate-400">
                Best finish
              </div>
              <div className="mt-2 text-2xl font-semibold text-slate-950">
                {summary.bestFinish || "-"}
              </div>
            </div>
            <div className="rounded-2xl border border-slate-200 bg-slate-50 px-4 py-4">
              <div className="text-[11px] uppercase tracking-[0.18em] text-slate-400">
                Parties comptabilisees
              </div>
              <div className="mt-2 text-2xl font-semibold text-slate-950">
                {summary.rankedGames}
              </div>
            </div>
          </div>
        </ProfileSectionCard>
      </div>

      <ProfileSectionCard
        title="Classement categorie"
        subtitle="Fallback propre en attendant de brancher un vrai top multi-categories cote profil."
      >
        <div className="space-y-3">
          {summary.topCategories.length === 0 ? (
            <div className="rounded-2xl border border-dashed border-slate-300 bg-slate-50 px-4 py-6 text-sm text-slate-500">
              Aucune donnee categorie suffisante pour afficher un classement personnel.
            </div>
          ) : (
            summary.topCategories.slice(0, 6).map((item, index) => (
              <div
                key={item.category}
                className="flex items-center justify-between rounded-2xl border border-slate-200 bg-white px-4 py-3"
              >
                <div className="flex items-center gap-3">
                  <div className="text-sm font-semibold text-slate-400">
                    #{index + 1}
                  </div>
                  <div>
                    <div className="font-semibold text-slate-900">{item.category}</div>
                    <div className="mt-1 text-xs text-slate-500">
                      {item.games} parties jouees
                    </div>
                  </div>
                </div>
                <div className="text-right">
                  <div className="text-lg font-semibold text-slate-950">
                    {item.totalScore}
                  </div>
                  <div className="text-[11px] uppercase tracking-[0.18em] text-slate-400">
                    score total
                  </div>
                </div>
              </div>
            ))
          )}
        </div>
      </ProfileSectionCard>
    </div>
  );
}
